import { Component, EventEmitter, Output } from '@angular/core';
import { IonicSharedModule } from '../../shared/ionic-shared.module';

@Component({
    selector: 'app-push-permission-modal',
    standalone: true,
    imports: [IonicSharedModule],
    templateUrl: './push-permission-modal.component.html',
    styleUrls: ['./push-permission-modal.component.scss']
})

export class PushPermissionModalComponent {
    isOpen = true;

    @Output() permissionRequested = new EventEmitter<void>();
    @Output() closeModal = new EventEmitter<void>();

    allow() {
        this.permissionRequested.emit();
        this.isOpen = false;
    }

    close() {
        this.isOpen = false;
        this.closeModal.emit();
    }

    onDismiss() {
        this.isOpen = false;
        this.closeModal.emit();
    }
}
